module.exports = __webpack_public_path__ + "static/img/afterPop.5430ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/afterPop.png
// module id = SnGO
// module chunks = 0